import { apiClient } from "@/services/api";
import { logError } from "@/lib/error-handling";
import { PublicUser } from "@/types";

/**
 * Fetches the currently authenticated user from the /api/me endpoint.
 * Throws an error if not authenticated.
 */
export const fetchCurrentUser = async (): Promise<PublicUser> => {
  try {
    return await apiClient<PublicUser>("/api/me", { method: "GET" });
  } catch (error) {
    logError(error, "fetchCurrentUser");
    throw error;
  }
};

/**
 * Logs out the current user by calling the logout API endpoint.
 * On success, redirects the browser to the WorkOS logout URL.
 * On failure, logs the error, reloads the page, and rethrows the error.
 */
export const logOutUser = async (): Promise<void> => {
  try {
    const response = await apiClient<{ url: string }>("/api/auth/logout", {
      method: "POST",
    });

    if (response?.url) {
      window.location.href = response.url;
    }
  } catch (error) {
    logError(error, "logOutUser");
    window.location.reload();
    throw error;
  }
};
